"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Base_1 = __importDefault(require("./Base"));
var firebase_1 = require("./firebase");
var Organizations = /** @class */ (function (_super) {
    __extends(Organizations, _super);
    function Organizations() {
        var _this = _super.call(this, "") || this;
        _this.get = function () {
            return _this.getByPath("/orgs/");
        };
        _this.createOrg = function (uid, orgObj) {
            if (orgObj.request.audit) {
                orgObj.request.audit.createdAt = firebase_1.dbConstants.ServerValue.TIMESTAMP;
                orgObj.request.audit.updatedAt = firebase_1.dbConstants.ServerValue.TIMESTAMP;
            }
            return _this.create("/apis/create_org/" + uid, orgObj);
        };
        _this.getIdsForUser = function (uid) {
            return _this.getByPath("/users_mapping/orgs/" + uid);
        };
        _this.getConfig = function (orgId) {
            return _this.getByPath("/orgs_config/" + orgId);
        };
        _this.getAuthRoles = function (orgId, uid) {
            return _this.getByPath("/users_mapping/orgs/" + uid + "/" + orgId);
        };
        _this.requestListMemebers = function (orgId, uid) {
            var obj = {
                request: {
                    audit: {
                        createdAt: firebase_1.dbConstants.ServerValue.TIMESTAMP,
                        createdBy: uid,
                    },
                    orgId: orgId
                }
            };
            return _this.create("/apis/list_members/" + uid, obj);
        };
        _this.getMembers = function (uid, requestId) {
            return _this.getByPath("/apis/list_members/" + uid + "/" + requestId + "/response");
        };
        _this.getUserIds = function (orgId) {
            return _this.getByPath("/orgs_users/" + orgId);
        };
        _this.requestChangeAccountType = function (orgId, uid, reqObj) {
            if (reqObj.request.audit) {
                reqObj.request.audit.createdAt = firebase_1.dbConstants.ServerValue.TIMESTAMP;
                reqObj.request.audit.updatedAt = firebase_1.dbConstants.ServerValue.TIMESTAMP;
            }
            return _this.create("/apis/" + orgId + "/" + uid + "/change_account_type", reqObj);
        };
        _this.requestDeActivateUser = function (orgId, uid, reqObj) {
            if (reqObj.request.audit) {
                reqObj.request.audit.createdAt = firebase_1.dbConstants.ServerValue.TIMESTAMP;
                reqObj.request.audit.updatedAt = firebase_1.dbConstants.ServerValue.TIMESTAMP;
            }
            return _this.create("/apis/" + orgId + "/" + uid + "/deactivate_user", reqObj);
        };
        _this.getUnRegisteredMembers = function (orgId) {
            return _this.getByPath("/invitations/" + orgId);
        };
        _this.invitePeople = function (orgId, uid, reqObj) {
            if (reqObj.request.audit) {
                reqObj.request.audit.createdAt = firebase_1.dbConstants.ServerValue.TIMESTAMP;
                reqObj.request.audit.updatedAt = firebase_1.dbConstants.ServerValue.TIMESTAMP;
            }
            return _this.create("/apis/" + orgId + "/" + uid + "/invite_user", reqObj);
        };
        _this.resendInvite = function (orgId, uid, reqObj) {
            if (reqObj.request.audit) {
                reqObj.request.audit.createdAt = firebase_1.dbConstants.ServerValue.TIMESTAMP;
                reqObj.request.audit.updatedAt = firebase_1.dbConstants.ServerValue.TIMESTAMP;
            }
            return _this.create("/apis/" + orgId + "/" + uid + "/resend_invitation", reqObj);
        };
        _this.revokeInvite = function (orgId, uid, reqObj) {
            if (reqObj.request.audit) {
                reqObj.request.audit.createdAt = firebase_1.dbConstants.ServerValue.TIMESTAMP;
                reqObj.request.audit.updatedAt = firebase_1.dbConstants.ServerValue.TIMESTAMP;
            }
            return _this.create("/apis/" + orgId + "/" + uid + "/revoke_invitation", reqObj);
        };
        _this.addUserToOrg = function (orgId, uid, reqObj) {
            if (reqObj.request.audit) {
                reqObj.request.audit.createdAt = firebase_1.dbConstants.ServerValue.TIMESTAMP;
                reqObj.request.audit.updatedAt = firebase_1.dbConstants.ServerValue.TIMESTAMP;
            }
            return _this.create("/apis/" + orgId + "/" + uid + "/add_user_to_org", reqObj);
        };
        _this.createDatasource = function (orgId, uid, datasourceObject) {
            return _this.create("/apis/" + orgId + "/" + uid + "/create_datasource", datasourceObject);
        };
        _this.updateDatasource = function (orgId, uid, datasourceObject) {
            return _this.create("/apis/" + orgId + "/" + uid + "/update_datasource_credentials", datasourceObject);
        };
        _this.createAnalysis = function (orgId, uid, analysisReq) {
            return _this.create("/apis/" + orgId + "/" + uid + "/create_analysis", analysisReq);
        };
        _this.createDashboard = function (orgId, uid, dashboardReq) {
            return _this.create("/apis/" + orgId + "/" + uid + "/create_dashboard", dashboardReq);
        };
        return _this;
    }
    return Organizations;
}(Base_1.default));
exports.default = Organizations;
//# sourceMappingURL=Organizations.js.map


//////////////////
// WEBPACK FOOTER
// ../api/lib/data/Organizations.js
// module id = 59
// module chunks = 8